import React from 'react';
import PlateRecognitionDisplay from '../../components/PlateRecognitionDisplay';

const PlateRecognition: React.FC = () => {
  return (
    <div>
      <h4 className="mb-3">
        <i className="fas fa-id-card me-2"></i>
        車牌辨識
      </h4>
      {/* 顯示所有攝像頭的辨識視圖 */}
      <PlateRecognitionDisplay showAllCameras={true} />
    </div>
  );
};

export default PlateRecognition;